import InitVueApp from '@/entry';
import App from '@/apps/login/001/App';
import store from '@/apps/login/store';
import '@/plugins/vee-validate';
import '@/plugins/google-recaptcha';
import { appElement } from '@/apps/login/config';

new InitVueApp(App, appElement, { store });


